<template>
  <div class="home-page">
    <!-- Navbar -->
    <navbar-home></navbar-home>

    <section class="ew-contact-layout">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8">
            <div class="ew-contact-form shadow rounded bg-white p-5">
              <div class="text-center mb-4">
                <h2 class="mb-1">Ponte en contacto con nosotros</h2>
                <p class="text-muted">Completa el formulario y uno de nuestros asesores te contactará.</p>
              </div>

              <div class="alert alert-danger" v-if="signinError">
                Su mensaje no pudo ser enviado.
              </div>

              <form @submit.prevent="sendMessage" novalidate>
                <!-- Nombre y Apellido -->
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label for="">Nombre <sup>*</sup></label>
                    <input type="text" class="form-control" v-model="first_name" required />
                  </div>

                  <div class="col-md-6 mb-3">
                    <label for="">Apellido <sup>*</sup></label>
                    <input type="text" class="form-control" v-model="last_name" required />
                  </div>
                </div>

                <!-- Email y Teléfono -->
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label for="">Email <sup>*</sup></label>
                    <input type="email" class="form-control" v-model="email" required />
                  </div>

                  <div class="col-md-6 mb-3">
                    <label for="">Teléfono <sup>*</sup></label>
                    <input type="text" class="form-control" v-model="phone" required />
                  </div>
                </div>

                <!-- Empresa y Web -->
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label for="">Nombre de tu negocio <sup>*</sup></label>
                    <input type="text" class="form-control" v-model="company_name" required />
                  </div>

                  <div class="col-md-6 mb-3">
                    <label for="">Sitio web</label>
                    <input type="text" class="form-control" v-model="web" placeholder="https://www.tusitio.com" />
                  </div>
                </div>

                <!-- Envíos y Comentarios -->
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label for="">¿Ya estás haciendo envíos? <sup>*</sup></label>
                    <select class="form-control" v-model="shipmets" required>
                      <option disabled value="">Selecciona una opción</option>
                      <option value="1">Sí</option>
                      <option value="0">No</option>
                    </select>
                  </div>

                  <div class="col-md-6 mb-3">
                    <label for="">Comentarios <sup>*</sup></label>
                    <input type="text" class="form-control" v-model="comments" required />
                  </div>
                </div>

                <!-- Envíos mensuales -->
                <div class="row" v-if="shipmets === '1'">
                  <div class="col-md-6 mb-4">
                    <label for="">Envíos mensuales <sup>*</sup></label>
                    <input type="number" class="form-control" v-model="n_shipping" required />
                  </div>
                </div>

                <!-- Botones -->
                <div class="text-center mt-4">
                  <router-link class="btn btn-outline-secondary mr-3" :to="islogin ? '/dashboard' : '/'">
                    Anterior
                  </router-link>
                  <button class="btn btn-primary px-5" type="submit" v-b-tooltip.hover.top="'Envía el mensaje de contacto'">
                    Enviar mensaje
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer global -->
      <AppFooter />
    </section>
  </div>
</template>

<script>
import AppFooter from "@/components/AppFooter.vue";
import NavbarHome from "@/components/Header/NavbarHome.vue";
import axios from 'axios'
import commons from '../commons'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Contact',
  data() {
    return {
      islogin: "",
      shipmets: "",
      signinError: false,
      first_name: '',
      last_name: '',
      company_name: '',
      email: '',
      phone: '',
      web: '',
      comments: '',
      n_shipping: 0
    }
  },
  watch: {},
  methods: {
    sendMessage() {
      axios
        .post(`${commons.apiURL}/api/v1/contact`, {
          first_name: this.first_name,
          last_name: this.last_name,
          company_name: this.company_name,
          email: this.email,
          phone: this.phone,
          web: this.web,
          message: this.comments,
          number_shipment: this.n_shipping
        })
        .then(response => {
          if (this.islogin) {
            this.$router.push('/shipments')
          } else {
            this.$router.push('/thank-page')
          }
        })
        .catch(error => {
          if (error.response.status === 500 || error.response.status === 404) {
            this.signinError = true
          }
        })
    },
    ...mapActions(['getUser'])
  },
  computed: {
    ...mapGetters(['user'])
  },
  created() {

    this.islogin = (localStorage.getItem('ew-user-id')) ? true : false;
    if (this.islogin) {
      axios
        .get(`${commons.apiURL}/api/v1/users/${localStorage.getItem('ew-user-id')}`)
        .then(response => {
          if (response.data) {
            this.first_name = response.data.firstName
            this.last_name = response.data.lastName
            this.email = response.data.email
            this.phone = response.data.phone
            localStorage.setItem('ew-user-role', response.data.rol);
          }
        })
        .catch(error => {
          if (error.response.status === 404) {

          }
        })
    }

  },
  components: {
    AppFooter,
    "navbar-home": NavbarHome
  },

}
</script>

<style scoped>
/* Layout principal */
.ew-contact-layout {
  background: #f5f7fa;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

/* 📄 Tarjeta del formulario */
.ew-contact-form {
  border-radius: 20px;
  max-width: 800px;
  margin: 4rem auto;
  transition: all 0.3s ease;
}

.ew-contact-form:hover {
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

/* ✏️ Labels e inputs */
label {
  font-weight: 600;
  color: #344767;
}

.form-control {
  border-radius: 8px;
  border: 1px solid #cfd8dc;
  padding: 0.7rem 1rem;
  font-size: 1rem;
}

.form-control:focus {
  border-color: #5b72a5;
  box-shadow: 0 0 0 0.2rem rgba(91, 114, 165, 0.25);
}

/* 📝 Titulos */
.ew-section-header {
  text-align: center;
  font-size: 2rem;
  color: #5b72a5;
  margin-bottom: 2rem;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue